import { Component, Input, OnInit } from '@angular/core';
import { DictEntryModel } from '../models/dict-entry.model';
import { SearchService } from '../services/search.service';
import { SuggestionModel } from '../models/suggestion.model';
import { NavigationService } from '../services/navigation.service';
import {HistorySearchService} from "../services/history-search.service";
import {FavoriteSearchService} from "../services/favorite-search.service";

@Component({
  selector: 'app-word',
  templateUrl: './word.component.html',
  styleUrls: ['./word.component.scss'],
})
export class WordComponent implements OnInit {

  wordDef: DictEntryModel = null;
  empty = false;
  morphInfo = [];
  loading = false;
  word = '';
  favorite = false;

  @Input()
  set input(input: { word: string; morph: boolean }) {
    if (input.word !== '') {
      this.loading = true;
      this.searchService.word(input.word).subscribe(
        (data: DictEntryModel) => {
          if (data.error) {
            this.wordDef = null;
          } else {
            this.wordDef = data;
            this.historySearchService.add(input.word);
          }
          this.word = input.word;
          this.favorite = this.favoriteService.present(input.word);
          this.loading = false;
        }
      );
    } else {
      this.empty = true;
    }

    if (input.morph) {
      this.loading = true;
      this.searchService.suggestions(input.word).subscribe((suggestions: SuggestionModel) => {
        console.log('presentForms', suggestions.presentForm);
        this.morphInfo = suggestions.analysis;
        this.searchService.word(suggestions.presentForm).subscribe(
          (data: DictEntryModel) => {
            this.wordDef = data;
            this.loading = false;
          }
        );
      });
    }
  }

  constructor(
    private searchService: SearchService,
    public navigationService: NavigationService,
    private historySearchService: HistorySearchService,
    private favoriteService: FavoriteSearchService,
  ) { }

  ngOnInit() {}

  toggleFavorite () {
    this.favoriteService.toggle(this.word);
    this.favorite = this.favoriteService.present(this.word);
  }

}
